"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateHotelRoom = exports.deleteHotelRoom = exports.getHotelRoom = exports.copyHotelRoom = exports.addHotelRoom = exports.getHotelContracts = exports.getHotelRooms = void 0;
const dayjs = require("dayjs");
const getHotelRooms = async (supabase, hotelId) => {
    const { data, error } = await supabase
        .from("hotel_rooms")
        .select(`*`)
        .eq("hotel_id", hotelId)
        .order("created_at", { ascending: true });
    if (!error)
        return data.map((room) => {
            return {
                ...room,
                hotel_id: hotelId,
            };
        });
    return error;
};
exports.getHotelRooms = getHotelRooms;
const getHotelContracts = async (supabase, hotelId, start_date, end_date) => {
    const start = dayjs(start_date).startOf("day").toDate();
    const end = dayjs(end_date).startOf("day").toDate();
    const { data, error } = await supabase
        .from("hotel_contracts")
        .select(`*, 
      hotel:hotel_id (id, name), 
      supplier:supplier_id (id, name, currency), 
      hotel_contract_notes(count),
      products:hotel_contract_products(
        *,
        hotel_room:hotel_rooms!hotel_room_id(id, name, view, room_size, max_occupancy, bed_options, images),
        rates:hotel_contract_product_rates(
          *
        )
      )`)
        .eq("hotel_id", hotelId);
    // filter the above so that only hotel contracts which
    if (!error) {
        // within each contract, filter the contract.date_bands to only contain bands that wrap around either the start or the end date
        data.forEach((contract) => {
            const bands = contract.price_bands.filter((band) => {
                const band_start = dayjs(band.from_date).startOf("day").toDate();
                const band_end = dayjs(band.to_date).startOf("day").toDate();
                return ((band_start <= start && band_end >= start) ||
                    (band_start <= end && band_end >= end) || // if the band wraps around the start or end date
                    (band_start >= start && band_end <= end) // or if the band is completely within the start and end date
                );
            });
            contract.price_bands = bands;
            contract.products.forEach((product) => {
                const rates = product.rates.map((rate) => {
                    const cancellation_policy = contract.cancellation_policies
                        ? contract.cancellation_policies.find((policy) => policy.id === rate.cancellation_penalty_id)
                        : null;
                    const discount = contract.discounts
                        ? contract.discounts.find((discount) => discount.id === rate.discount_id)
                        : null;
                    return {
                        ...rate,
                        cancellation_policy: cancellation_policy,
                        discount: discount,
                    };
                });
                product.rates = rates;
            });
        });
        return data;
    }
    return error;
};
exports.getHotelContracts = getHotelContracts;
const addHotelRoom = async (supabase, room) => {
    const { data, error } = await supabase
        .from("hotel_rooms")
        .insert([room])
        .select();
    if (!error)
        return data;
    return error;
};
exports.addHotelRoom = addHotelRoom;
const copyHotelRoom = async (supabase, room) => {
    const { data, error } = await supabase
        .from("hotel_rooms")
        .insert([room])
        .select();
    if (!error)
        return data;
    return error;
};
exports.copyHotelRoom = copyHotelRoom;
const getHotelRoom = async (supabase, id) => {
    const { data: room, error } = await supabase
        .from("hotel_rooms")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error)
        return room;
    return error;
};
exports.getHotelRoom = getHotelRoom;
const deleteHotelRoom = async (supabase, id) => {
    const { data, error } = await supabase
        .from("hotel_rooms")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteHotelRoom = deleteHotelRoom;
const updateHotelRoom = async (supabase, room) => {
    const { data, error } = await supabase
        .from("hotel_rooms")
        .update(room)
        .eq("id", room.id);
    if (!error)
        return data;
    return error;
};
exports.updateHotelRoom = updateHotelRoom;
